/**
 * API 文件 / 角色管理 API 的顯示規則（第一階段：只管後台畫面，API key 本身後端尚未擋）
 *   經銷商、超管 → 一律看得到
 *   其他（商用帳號、子帳號）→ 看目前租戶的旗標；預設關閉，由超管在超管中心逐租戶開通
 *   角色管理 API 只在 API 文件也開時才算開（關掉 API 文件時旗標保留，但不生效）
 * 後端第二階段的檢查要跟這裡同一套規則（見 saasAdmin.js PATCH /tenants/:hostId/api-access 註解）。
 */
export function apiAccess(accountRole, tenant) {
    if (accountRole === 'dealer' || accountRole === 'super_admin') return { docs: true, avatar: true };
    const docs = tenant?.apiDocsEnabled === true;
    return { docs, avatar: docs && tenant?.avatarApiEnabled === true };
}
